const teamStatusTypes = {
    team: 'TEAM',
    opponent: 'OPPONENT',
    both: 'BOTH'
};

export default teamStatusTypes;
